<!--169 CopyFeatureSystemJob-->


<div class="dx-field">
    <div class="dx-field-label">{{ 'Merkmalsgruppe' | translate }}</div>
    <div class="dx-field-value">
        <dx-load-indicator *ngIf="!featureSystemLoded"></dx-load-indicator>
        <dx-select-box [(value)]="selectedFeatureSystemToCopy"
                       [dataSource]="featureSystems"
                       displayExpr="name"
                       [searchEnabled]="true"
                       valueExpr="id"
                       placeholder=""></dx-select-box>
    </div>
</div>


<div class="dx-field">
    <div class="dx-field-label">{{ 'Neuer Name' | translate }}</div>
    <div class="dx-field-value">
        <dx-text-area [(value)]="newNameForFeatureSystem"
                      placeholder=""></dx-text-area>
    </div>
</div>